<h5 class="pb-0 text-white m-0">{{currentUser?.firstName}} {{currentUser?.lastName}}</h5>
<button mat-button [matMenuTriggerFor]='menu'>
  <mat-icon class="text-white">menu</mat-icon>

</button>
<mat-menu #menu='matMenu' class='mr-sm'>
  <!--a mat-menu-item *ngFor='let item of primeItems' [routerLink]='item.target'>{{item.label}}</a-->
  <button mat-menu-item
    *ngFor='let item of primeItems'
    [routerLink]='item.target'
    (click)="onMenuItemClick(item)">{{item.label}}</button>
  <mat-divider></mat-divider>
  <button mat-menu-item *ngIf='isAuthenticated' (click)='logout()'>Logout</button>
  <button mat-menu-item routerLink='/login' *ngIf='!isAuthenticated'>Login</button>
  <!--button mat-menu-item (click)='testEngineHint()'>Test Engine Hint</button-->
</mat-menu>
